// extracted by mini-css-extract-plugin
export default {"block":"Block-module__block--drlUv","icon":"Block-module__icon--Aiw2E","active":"Block-module__active--ac3XQ"};